export default __webpack_public_path__ + "static/event4-a6d69a78d7269591f92bcbcb248a920e.jpg";